import { render, staticRenderFns } from "./checkRiskTwo.vue?vue&type=template&id=4d2742f4&scoped=true&"
import script from "./checkRiskTwo.vue?vue&type=script&lang=js&"
export * from "./checkRiskTwo.vue?vue&type=script&lang=js&"
import style0 from "./checkRiskTwo.vue?vue&type=style&index=0&id=4d2742f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2742f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2742f4')) {
      api.createRecord('4d2742f4', component.options)
    } else {
      api.reload('4d2742f4', component.options)
    }
    module.hot.accept("./checkRiskTwo.vue?vue&type=template&id=4d2742f4&scoped=true&", function () {
      api.rerender('4d2742f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/checkRiskTwo.vue"
export default component.exports